import React from "react";
import PropTypes from "prop-types";

export default function StudioSidebar({
  title = "Studio",
  activePanel = null,
  panels = [],
  onPanelChange = null,
}) {
  const activeEntry =
    panels.find((panel) => panel.id === activePanel) ||
    panels[0] ||
    null;

  return (
    <aside className="studio-sidebar">
      <header className="studio-sidebar__header">
        <p className="studio-sidebar__eyebrow">Workspace</p>
        <h3>{title}</h3>
      </header>

      {panels.length > 0 && (
        <nav className="studio-sidebar__tabs" aria-label={`${title} panels`}>
          {panels.map((panel) => {
            const isActive = activeEntry?.id === panel.id;

            return (
              <button
                key={panel.id}
                type="button"
                className={`studio-sidebar__tab ${
                  isActive ? "studio-sidebar__tab--active" : ""
                }`}
                onClick={() => onPanelChange?.(panel.id)}
              >
                {panel.label}
              </button>
            );
          })}
        </nav>
      )}

      <div className="studio-sidebar__content">
        {activeEntry?.content || null}
      </div>
    </aside>
  );
}

StudioSidebar.propTypes = {
  title: PropTypes.string,
  activePanel: PropTypes.string,
  panels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      content: PropTypes.node,
    })
  ),
  onPanelChange: PropTypes.func,
};
